import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke070d',
  templateUrl: './sgke070d.component.html',
  styleUrl: './sgke070d.component.scss'
})
export class Sgke070dComponent implements OnInit, OnDestroy {
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 充当ラジオボタン */
  registType: string = '';

  /** 未精算金管理番号 */
  kinkoMno: string = '200000000000001';
  /** 未精算金履歴番号 */
  kinkoRrkno: string = '3001';
  /** 未精算金_更新通番号 */
  kinkoUpdateSrno: string = '50001';
  /** 未精算金EX_更新通番号 */
  kinkoexUpdatesequencenumber: string = '60001';
  /** 未精算ステータスコード */
  kinkoStatuscode: string = '';

  /**
   * コンストラクタ
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke070dComponent
   */
  constructor(
    public responseMsgUtils: ResponseMsgUtils,
  ) { }

  /**
   * 初期処理
   * @memberof Sgke070dComponent
   */
  ngOnInit(): void {
  }
  /**
   * 購読解除
   * @memberof Sgke070dComponent
   */
  ngOnDestroy() {
  }

  /**
   * ラジオボタン押下時(sgke020dから呼ばれる再現)
   * @param {string[]} event
   * @memberof Sgke070dComponent
   */
  onChangeRadio(event: string[]): void {
    this.registType = event[0];
    this.kinkoStatuscode = event[1];
  }

  /**
   * sgke020d再描画再現
   * @memberof Sgke070dComponent
   */
  public search() {
    this.registType = '';
  }

  /**
   * エラーメッセージ表示
   * @memberof Sgke070dComponent
   */
  showMsg(errors) {
    // メッセージを表示
    this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(errors, this.errorMessageModelArray);
  }
  /**
   * エラーメッセージ表示領域をクリア
   * @memberof Sgke070dComponent
   */
  public clearErrorMsg() {
    if (this.errorMessageModelArray) {
      this.errorMessageModelArray.length = 0;
    }
  }
}